import { render, staticRenderFns } from "./salon_create.vue?vue&type=template&id=01207604&scoped=true"
import script from "./salon_create.vue?vue&type=script&lang=js"
export * from "./salon_create.vue?vue&type=script&lang=js"
import style0 from "./salon_create.vue?vue&type=style&index=0&id=01207604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01207604",
  null
  
)

export default component.exports